import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import { Button, InlineTextButton, Modal, Form, CustomExtendedDataField } from '../../components';
import { getPropsForCustomUserFieldInputs } from '../../util/userHelpers';
import css from './ProfileModal.module.css';
import arrayMutators from 'final-form-arrays';
import { pickUserFieldsData } from '../../util/userHelpers';
import { updateProfile } from '../../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import { useHistory } from 'react-router-dom';
const ProfileModalComponent = props => {
  const {
    onManageDisableScrolling,
    isProfileModalOpen,
    setIsProfileModalOpen,
    config,
    user,
    onUpdateProfile,
    setIsUploadPassportOpen,
    isFromCreateListing,
  } = props;
  const history = useHistory();
  const handleClose = () => {
    setIsProfileModalOpen(false);
    if (isFromCreateListing) {
      history.goBack();
    }
  };

  const closeButtonMessage = ' ';
  const [currentStep, setCurrentStep] = useState(1);
  const [showStepWarning, setShowStepWarning] = useState(false);
  const { publicData, privateData } = user?.attributes.profile;
  const { userType } = publicData || {};
  const { userFields } = config.user;
  const initialPassport = privateData?.idorpassport || null;

  const userfieldkeys = userFields.map(field => field.key);

  const missingFields = userfieldkeys.filter(
    key => !publicData[key] || publicData[key]?.length === 0
  );

  const onSubmit = async (formValues, userType) => {
    const isNewlyAddedDob = false;
    const isPassportUpdated = false;

    const incomplete = missingFields.some(key => {
      const value = formValues[`pub_${key}`];
      return (
        value === undefined ||
        value === null ||
        (typeof value === 'string' && value.trim() === '') ||
        (Array.isArray(value) && value.length === 0)
      );
    });

    if (incomplete) {
      setShowStepWarning(true);
      return;
    }

    const rawPublicData = pickUserFieldsData(formValues, 'public', userType, userFields);
    const cleanedPublicData = Object.entries(rawPublicData).reduce((acc, [key, value]) => {
      if (value !== null && value !== undefined) {
        acc[key] = value;
      }
      return acc;
    }, {});

    const params = {
      publicData: cleanedPublicData,
    };

    const result = await onUpdateProfile({ ...params, isNewlyAddedDob, isPassportUpdated });

    if (result?.success) {
      setIsProfileModalOpen(false);
    }
    // const missingFieldsLength = missingFields ? missingFields.length : 0;
    // const cleanedFieldsLength = Object.keys(cleanedPublicData).length;
    // if (isFromCreateListing && missingFieldsLength > cleanedFieldsLength) {
    //     history.goBack();
    // }
    // if (!initialPassport) {
    //     setIsUploadPassportOpen(true);
    // }
  };

  return (
    <FinalForm
      {...props}
      mutators={{ ...arrayMutators }}
      onSubmit={onSubmit}
      render={fieldRenderProps => {
        const {
          className,
          // currentUser,
          intl,
          invalid,

          handleSubmit,
          pristine,
          updateInProgress,
          updateProfileError,
          form,
          formId,
          marketplaceName,
          values,
          submitFailed,
        } = fieldRenderProps;

        // const requiredFields = userFields
        //     .filter(field => field?.saveConfig?.isRequired)
        //     .map(field => field.key);

        const missingUserFields = userFields.filter(field => missingFields.includes(field.key));
        const userFieldProps = getPropsForCustomUserFieldInputs(
          missingUserFields,
          intl,
          userType,
          false
        );

        const step1Fields = userFieldProps.slice(0, Math.ceil(userFieldProps.length / 2));
        const step2Fields = userFieldProps.slice(Math.ceil(userFieldProps.length / 2));

        const handleNext = () => {
          const currentFields = step1Fields.map(field => field.key);
          const incomplete = currentFields.some(key => !values[key] || values[key]?.length === 0);

          if (incomplete) {
            setShowStepWarning(true);
          } else {
            setShowStepWarning(false);
            setCurrentStep(2);
          }
        };
        return (
          <Modal
            id="ProfileModal"
            containerClassName={css.ProfileModal}
            isOpen={isProfileModalOpen}
            onClose={handleClose}
            usePortal
            onManageDisableScrolling={onManageDisableScrolling}
            closeButtonMessage={closeButtonMessage}
          >
            <Form onSubmit={handleSubmit}>
              <div className={css.sectionContainer}>
                {currentStep === 1 &&
                  missingFields.length <= 4 &&
                  userFieldProps.map(fieldProps => (
                    <CustomExtendedDataField {...fieldProps} formId={formId} values={values} />
                  ))}

                {currentStep === 1 &&
                  missingFields.length > 4 &&
                  step1Fields.map(fieldProps => (
                    <CustomExtendedDataField {...fieldProps} formId={formId} values={values} />
                  ))}

                {currentStep === 2 &&
                  step2Fields.map(fieldProps => (
                    <CustomExtendedDataField {...fieldProps} formId={formId} values={values} />
                  ))}
              </div>

              <div className={css.buttonContainer}>
                {showStepWarning && (
                  <div className={css.warningMessage}>
                    <FormattedMessage id="ProfileModal.completeAllFields" />
                  </div>
                )}
                {currentStep === 1 && missingFields.length > 4 && (
                  <Button type="button" onClick={handleNext}>
                    <FormattedMessage id="ProfileModal.next" />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      className="arrow-icon"
                      width="16"
                      height="16"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M3 12h18"
                      />

                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                        d="M15 6l6 6-6 6"
                      />
                    </svg>
                  </Button>
                )}
                <div className={css.stepIndicatorButtons}>
                  {currentStep === 2 && (
                    <>
                      <InlineTextButton
                        className={css.backButton}
                        type="button"
                        onClick={() => {
                          setCurrentStep(1);
                          setShowStepWarning(false);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          className="arrow-icon-left"
                          width="16"
                          height="16"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M15 19l-7-7 7-7"
                            fill="none"
                          />
                        </svg>

                        <FormattedMessage id="ProfileModal.back" />
                      </InlineTextButton>
                    </>
                  )}

                  {missingFields.length > 4 && (
                    <div className={css.stepIndicator}>
                      <span>{currentStep} of 2</span>
                    </div>
                  )}

                  {currentStep === 1 && missingFields.length <= 4 && (
                    <Button
                      className={css.submitButton}
                      type="submit"
                      inProgress={updateInProgress}
                      disabled={updateInProgress || pristine}
                    >
                      <FormattedMessage id="ProfileModal.submitButton" />
                    </Button>
                  )}
                </div>

                {currentStep === 2 && (
                  <Button
                    className={css.submitButton}
                    type="submit"
                    inProgress={updateInProgress}
                    disabled={updateInProgress || pristine}
                  >
                    <FormattedMessage id="ProfileModal.submitButton" />
                  </Button>
                )}
              </div>
            </Form>
          </Modal>
        );
      }}
    />
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { updateInProgress, updateProfileError } = state.ProfileSettingsPage;
  return {
    currentUser,
    // scrollingDisabled: isScrollingDisabled(state),
    updateInProgress,
    updateProfileError,
  };
};

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: data => dispatch(updateProfile(data)),
});

const ProfileModal = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(ProfileModalComponent);

export default ProfileModal;
